module.exports = __webpack_public_path__ + "static/media/plus.b927bb5f.png";